<template>
    <v-app>
        <header-card-public ref="refHeader" current_page="landing"></header-card-public>
        <v-content :class="isMobile?'section1-mobile':'section1'">
            <v-layout v-if="!isMobile" fill-height align-center row wrap>
                <v-flex xs12 sm7>
                    <div :class="isMobile?'section1-mobile-div':'section1-div'">
                        <!-- mark-up texts for better SEO -->
                        <span class="section1-main-header text-xs-left white--text" >
                            {{ content.default.title }}
                        </span><br>
                        <span class="section1-main-sub-header">
                           {{ content.default.description1 }}
                        </span>
                        <p class="section1-main-description text-xs-left">
                            {{ content.default.description2 }}
                        </p>
                         <v-btn color="#1976D2" round block dark @click="showBookForDemo">
                            <v-icon>app_registration</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button1}}
                        </v-btn>
                        <v-btn color="#F44336" round dark @click="showProductDemo">
                            <v-icon>fab fa-youtube</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button2}}
                        </v-btn>
                        <v-btn color="cyan" outline round block dark @click="scrollDown">
                            <v-icon>local_library</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button3}}
                        </v-btn>
                    </div>
                </v-flex>
                <v-flex xs12 sm5>
                    <div class="face-ai-container">                        
                        <v-img :src="require('@/assets/landing/FaceAI-mockup2.png')" width="200" class="mx-auto"></v-img>
                        <span class="section1-main-header2 white--text">
                            SweldoNow FaceAI
                        </span>
                        <p class="caption">
                            A cloud-based facial recognition attendance tracker that works on your cellphone or tablet, fully integrated with SweldoNow payroll services.
                            <!-- <v-btn flat small dark @click="scrollDown" style="margin-top:0px;">Learn More</v-btn> -->
                        </p>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout v-if="isMobile" fill-height align-center row wrap>
                <v-flex xs12 sm6>
                    <div class="section1-mobile-div">
                        <div style="margin:10px 0px 10px 0px;">   
                            <div class="section1-main-header text-xs-center white--text" >
                                {{ content.default.title }}
                            </div>
                            <div class="subheading text-xs-center section1-main-sub-header-mobile">
                               {{ content.default.description1 }}
                            </div>
                            <!-- <div class="section1-main-header2-mobile text-xs-center">
                                <b>SweldoNow FaceAI</b> - A cloud-based facial recognition attendance tracker that works on your cellphone or tablet.
                            </div> -->
                            <v-img :src="require('@/assets/landing/FaceAI-mockup2.png')" width="160" class="mx-auto"></v-img>
                        </div>
                        <div class="text-xs-center">
                            <v-btn color="#1976D2" round block dark @click="showBookForDemo">
                                <v-icon>app_registration</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button1}}
                            </v-btn>
                            <v-btn color="red" round block dark @click="showProductDemo">
                                <v-icon>fab fa-youtube</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button2}}
                            </v-btn>
                            <v-btn color="cyan" outline round block dark @click="scrollDown">
                                <v-icon>local_library</v-icon>&nbsp;&nbsp;&nbsp;{{content.default.button3}}
                            </v-btn>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-content>
        
        <v-content>
            <div v-for="(item,index) in content.details" :key="index">
                <section-content :data="item" :image_location="index%2==0?'right':'left'" :section_class="`section-${index%2==0?'right':'left'}`" :id="item.id" :section_id="item.id"></section-content>
            </div>
        </v-content>

        <!-- FOOTER -->
        <v-footer dark height="auto">
            <footer-card></footer-card>
        </v-footer>
        
        <!-- <cookie-alert v-if="cookieDialog" :cookieDialog.sync="cookieDialog"></cookie-alert> -->

        <v-snackbar v-model="isNoInternet" color="warning" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="0" :top="y === 'top'" :vertical="mode === 'vertical'"
            >You have no internet connection.
        </v-snackbar>
    </v-app>
</template>
<script>

import * as easings from 'vuetify/es5/util/easing-patterns'
import '@/assets/css/public-FaceAI.css' 

export default {
    name: 'Portal',
    metaInfo: {
        title: 'Portal',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'section-content': () => import('@/components/SectionContent'),
        'header-card-public': () => import('@/components/HeaderPublic'),
        'footer-card': () => import('@/components/Footer'),
        // 'cookie-alert': () => import('@/components/CookieAlert'),
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            duration: 750,
            offset: 70,
            mode: null,
            x: null,
            y: null,
            easing: 'easeInOutCubic',
            dialogConfirmation: false,
            cookieDialog: false,
            isNoInternet: false,

            //static content data for faster loading
            content: {
                default: {
                    title: 'Cut Costs with Cloud-Based Face Recognition on Mobile',
                    description1: 'No On-Premises Servers Needed',
                    description2: 'Cloud based, BIR-certified tax reports, one-click payroll and annualization processing, attendance tracking, employee self-service, approval workflows, finance tools, and more - all in one platform.',
                    button1: 'Book a free demo',
                    button2: 'Watch Product Demo',
                    button3: 'Learn more'
                },
                faceAIsection: {

                },
                details: [
                    {
                        id: "testimonials",
                        nextId: "customers",
                        title: "What Our Customers Say",
                        description: `Real feedback from professionals using SweldoNow — shared publicly on Reddit’s <a href="https://www.reddit.com/r/payrollphilippines/comments/1nnsv5w/comment/nggmxl2/?force-legacy-sct=1" target="_blank" rel="noopener">r/payrollphilippines</a> community.`,
                        details: [
                            {
                                icon: "star",
                                title: "AccountantWiz",
                                description: "We've used SweldoNow for months — fast support, smooth system, and customized reports at no extra cost."
                            },
                            {
                                icon: "support_agent",
                                title: "AccountantWiz",
                                description: "The founder personally assists us in our requests. Their response time is quick and efficient."
                            },
                            {
                                icon: "verified_user",
                                title: "HRwhy",
                                description: "Good to know SweldoNow supports several time shifts and approval workflows — exactly what we need."
                            },
                            {
                                icon: "face_retouching_natural",
                                title: "OutsourceBPO",
                                description: "Face AI setup was easy and works great. Our attendance tracking is 99% accurate."
                            },
                            {
                                icon: "payments",
                                title: "OutsourceBPO",
                                description: "They also have Loan and Cash Advance features built-in. Very convenient for our team."
                            },
                            {
                                icon: "lock",
                                title: "OutsourceBPO",
                                description: "The program feels secure, and their team is accommodating and helpful during demos."
                            }
                        ],
                        image: {
                            fileName: "testimonials.jpg",
                            orientation: "landscape"
                        }
                    },
                    {
                        id: 'customers',
                        nextId: 'cloud',
                        title: 'Supporting Large Workforces',
                        description: 'SweldoNow is trusted by businesses with large workforces such as BPOs, shared services, and manufacturing companies. Our platform handles complex requirements including attendance tracking, night differential, undertime, and flexible salary structures.',
                        details: [
                            {
                                icon: 'groups',
                                title: 'High-volume workforce',
                                description: 'Supports companies with hundreds of employees across multiple shifts and schedules.'
                            },
                            {
                                icon: 'schedule',
                                title: 'Shift and attendance tracking',
                                description: 'Accurately handles attendance monitoring for day, mid, and night shifts including automated night differential computation.'
                            },
                            {
                                icon: 'payments',
                                title: 'Flexible salary structures',
                                description: 'Seamlessly manages different pay rules including hourly, daily, and monthly salary structures.'
                            },
                        ],
                        image: {
                            fileName: 'our-customers2.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: 'cloud',
                        nextId: 'faceai',
                        title: 'Cloud app',
                        description: 'Access your data from anywhere, anytime and effortlessly collaborate with your team using our intuitive  cloud-based app.',
                        details: [
                            {
                                icon: 'savings',
                                title: 'Cost savings',
                                description: 'Helps your business reduce costs by eliminating the need for expensive hardware and software installations.'
                            },
                            {
                                icon: 'cloud_sync',
                                title: 'Increased efficiency',
                                description: 'Automates many of the time-consuming manual tasks, freeing up HR personnel to focus on their important tasks.'
                            },
                        ],
                        image: {
                            fileName: 'cloud1.png',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: 'faceai',
                        nextId: 'attendance',
                        title: 'Facial Recognition Attendance',
                        description: 'With SweldoNow FaceAI, employees can easily clock in/out using any standard tablet or cellphone. Simply place a device in the office lobby for quick attendance logging—no proprietary hardware or servers needed. Fully integrated with SweldoNow, FaceAI offers real-time synchronization across multiple locations.',
                        details: [
                            {
                                icon: 'cloud_sync',
                                title: 'Real-time sync across locations',
                                description: 'Attendance data stays updated instantly within SweldoNow, no matter where employees check in.'
                            },
                            {
                                icon: 'security',
                                title: 'No special hardware needed',
                                description: 'Use a typical cellphone or tablet, offering a flexible and cost-effective tracking solution.'
                            },
                        ],
                        image: {
                            fileName: 'FaceAI-mockup2.png',
                            orientation: 'portrait'
                        }
                    },
                    {
                        id: "attendance",
                        nextId: 'workshiftplan',
                        title: 'Selfie Attendance Tracking',
                        description: 'Ideal for remote and field workers, the Selfie Attendance Tracker enables employees to clock in/out securely from any location with internet access, supporting flexible and offsite work arrangements.',
                        details: [
                            {
                                icon: 'camera_front',
                                title: 'Selfie attendance tracker',
                                description: 'Employees can log attendance with a selfie from their phone or tablet, making it easy to track time accurately for remote and on-the-go teams.'
                            },
                            {
                                icon: 'photo_camera',
                                title: 'Enhanced Verification',
                                description: 'Each selfie includes the background as proof, confirming the employee’s presence in the designated location when clocking in/out.'
                            }
                        ],
                        image: {
                            fileName: 'attendance1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "workshiftplan",
                        nextId: 'selfservice',
                        title: 'Workshift Planning',
                        description: 'Streamline employee scheduling with SweldoNow’s Workshift Planning. Perfect for managing both flexible and fixed shifts, this feature helps supervisors assign and visualize team schedules with ease.',
                        details: [
                            {
                                icon: 'assignment',
                                title: 'Customizable Shift Setup',
                                description: 'Define workshift types with clock-in/out times, break durations, and shift colors for easier tracking. Supports flexible and strict scheduling formats.'
                            },
                            {
                                icon: 'calculate',
                                title: 'Smart Calculations & Assignments',
                                description: 'Supervisors can plan future team shifts while the system automatically calculates night differential, tardiness, and overtime based on attendance data.'
                            }
                        ],
                        image: {
                            fileName: 'workshift-plan1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "selfservice",
                        nextId: 'hr201files',
                        title: 'Self service',
                        description: 'Allows employees to manage their own payroll information, such as updating personal information, filing timeoff, project charges, reimbursements, cash advances and loan payments.',
                        details: [
                            {
                                icon: 'savings',
                                title: 'Time and cost savings',
                                description: 'Saves HR personnel time and resources that would otherwise be spent on manual data entry and employee inquiries.'
                            },
                            {
                                icon: 'fact_check',
                                title: 'Improved accuracy',
                                description: 'When employees can access and update their own information, errors are less likely to occur, as there is no need for HR staff to manually input data. '
                            },
                        ],
                        image: {
                            fileName: 'selfservice1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "hr201files",
                        nextId: 'approval',
                        title: 'HR 201 Files',
                        description: `Easily manage and secure employee records with SweldoNow’s HR 201 Files. Files are uploaded directly to our AWS cloud server for safe, centralized storage with easy access and in-app preview.`,
                        details: [
                            {
                                icon: 'folder_copy',
                                title: 'Customizable & Organized',
                                description: 'Create your own HR 201 folder structure with custom names and colors to neatly organize employee documents.'
                            },
                            {
                                icon: 'cloud_done',
                                title: 'Secure & Accessible',
                                description: 'Drag-and-drop uploads directly to AWS cloud, with one-click previews for PDFs, images, and Word files. Control access through team-based permissions.'
                            },
                        ],
                        image: {
                            fileName: 'hr201files.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "approval",
                        nextId: 'access',
                        title: 'Approval workflow  & traceability',
                        description: 'Helps improve accuracy and auditability, making it an essential tool for businesses looking to streamline their payroll processes.',
                        details: [
                            {
                                icon: 'fact_check',
                                title: 'Improved accuracy',
                                description: 'Helps to ensure that payroll information is reviewed and approved by the appropriate individuals, reducing the risk of errors and inaccuracies'
                            },
                            {
                                icon: 'published_with_changes',
                                title: 'Auditability',
                                description: 'Traceability provides an audit trail that can be used to investigate any issues that arise in the payroll system.'
                            }
                        ],
                        image: {
                            fileName: 'approval1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "access",
                        nextId: 'compensation',
                        title: 'Access permissions',
                        description: 'By implementing effective access controls, organizations can better manage and protect sensitive payroll data, which can help to improve business operations and reduce risk.',
                        details: [
                            {
                                icon: 'admin_panel_settings',
                                title: 'Authorization',
                                description: 'Helps to ensure that only authorized personnel have access to payroll data. This helps to maintain the confidentiality, integrity, and availability of payroll data.'
                            },
                            {
                                icon: 'manage_accounts',
                                title: 'Flexibility',
                                description: 'It can be customized to meet the specific needs of an organization, such as designating approval rights to a senior employee if the supervisor is on leave.'
                            }
                        ],
                        image: {
                            fileName: 'accesspermissions1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "compensation",
                        nextId: 'payroll',
                        title: 'Compensation & benefits',
                        description: 'Customize pay grade, salary, leaves, and benefits alongside an efficient approval workflow and a traceable update history.',
                        details: [
                            {
                                icon: 'dashboard_customize',
                                title: 'Customization',
                                description: 'Employers can customize their compensation and benefits packages to meet the specific needs of their workforce.'
                            },
                            {
                                icon: 'tune',
                                title: 'Flexibility',
                                description: 'Provides flexibility to employers to make changes in pay and benefits programs as per the evolving needs of their workforce.'
                            }
                        ],
                        image: {
                            fileName: 'compensation1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "payroll",
                        nextId: 'annualiztion',
                        title: 'Payroll processing',
                        description: 'Automating the payroll process eliminates manual calculations and data entry, saving significant time for payroll personnel.',
                        details: [
                            {
                                icon: 'summarize',
                                title: 'One-click processing',
                                description: 'Process your payroll quickly and easily, one employee at a time or in batches.'
                            },
                            {
                                icon: 'fas fa-file-pdf',
                                title: 'Pre-filled certified BIR Reports',
                                description: 'Eliminate the need for manual completion of BIR reports such as <b>BIR 1601-C</b> and <b>BIR 1603-Q</b>. These are readily available for download in PDF format.'
                            }
                        ],
                        image: {
                            fileName: 'paryoll1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "annualiztion",
                        nextId: 'finance',
                        title: 'Annualization',
                        description: 'The process of consolidating employee&lsquo;s entire year payroll to calculate leaves conversion, benefits tax and final income tax.',
                        details: [
                            {
                                icon: 'summarize',
                                title: 'One-click annualization',
                                description: 'Compute employee&lsquo;s annualization in one click. Generates leaves conversion, final benefits tax, final income tax, and final adjustment amount.'
                            },
                            {
                                icon: 'fas fa-file-pdf',
                                title: 'Pre-filled certified BIR Reports',
                                description: 'Eliminate the need for manual completion of BIR reports such as <b>BIR 2316</b>, and <b>BIR 1604-C</b>. These are readily available for download in PDF format.'
                            }
                        ],
                        image: {
                            fileName: 'annualization1.jpg',
                            orientation: 'landscape'
                        }
                    },                    
                    {
                        id: "finance",
                        nextId: 'projects',
                        title: 'Finance tools',
                        description: 'Integrated finance tools such as <b>Reimbursements</b>, <b>Cash Advances</b> and <b>Loan Payments</b>. Helps reduce the time and effort required to manage them separately and can help to minimize errors and delays.',
                        details: [
                            {
                                icon: 'redeem',
                                title: 'Self service tool',
                                description: 'Employees can file for Reimbursements, Cash Advances and Loan Payments. Finance managers can then review and approve or reject the request.'
                            },
                            {
                                icon: 'credit_score',
                                title: 'Improved accuracy',
                                description: 'Helps to ensure that financial transactions are accurately recorded and accounted for. This can help to reduce errors and prevent fraudulent activities.'
                            }
                        ],
                        image: {
                            fileName: 'finance1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "projects",
                        nextId: 'security',
                        title: 'Projects',
                        description: 'Integrated simple project management tool. Create projects and sub tasks, set project duration, and define whether project is billable or not.',
                        details: [
                            {
                                icon: 'task',
                                title: 'Project charges',
                                description: 'Employees can submit project charges on a daily or weekly basis, and supervisors can then review and approve or reject them.'
                            },
                            {
                                icon: 'checklist_rtl',
                                title: 'Simplified tracking',
                                description: 'Review attendance, timeoff, and project charges side by side in one tool.'
                            }
                        ],
                        image: {
                            fileName: 'projects1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "security",
                        nextId: 'themes',
                        title: 'Enhanced security',
                        description: 'Helps improve reliability and availability of cloud applications by reducing the risk of security breaches or downtime caused by security incidents.',
                        details: [
                            {
                                icon: 'verified_user',
                                title: '2 factor authentication',
                                description: 'Provides additional layer of security beyond a simple password, making it more difficult for attackers to gain unauthorized access.'
                            },
                            {
                                icon: 'enhanced_encryption',
                                title: 'Encrypted data',
                                description: 'Personal identifiable information is crucially safeguarded through secure encryption within the database, ensuring enhanced privacy and protection against unauthorized access.'
                            }
                        ],
                        image: {
                            fileName: 'security1.jpg',
                            orientation: 'landscape'
                        }
                    },
                    {
                        id: "themes",
                        title: 'Themes',
                        description: 'Personalize your user interface according to your preferences. Customize your experience and enjoy a seamless and visually pleasing interface.',
                        details: [
                            {
                                icon: 'palette',
                                title: 'Change color',
                                description: 'Select a color scheme that suits your taste and enhances your visual experience while using the system.'
                            },
                            {
                                icon: 'settings_brightness',
                                title: 'Light or dark mode',
                                description: 'Adjust the display based on your environment and personal preference, providing a visually pleasing and comfortable experience.'
                            }
                        ],
                        image: {
                            fileName: 'themes1.jpg',
                            orientation: 'landscape'
                        }
                    },
                ]
            }
         }
    },
    methods: {
        showPricing() {
            this.$refs.refHeader.showPricing()
        },
        showBookForDemo() {
            this.$router.push('/book-demo')
        },
        showProductDemo() {
            window.open("https://help.sweldonow.ph/demo/")
        },
        showConfirmation() {
            this.dialogConfirmation = true
        },
        scrollDown() {
            this.$vuetify.goTo(this.firstSection, this.options)
        },
        updateConnectionStatus() {
            this.isNoInternet = !navigator.onLine;
            this.isSlowInternet = navigator.connection.downlink < 1.5
        },
    },
    created() {
        window.addEventListener('online', this.updateConnectionStatus);
        window.addEventListener('offline', this.updateConnectionStatus);
        this.updateConnectionStatus();

        const savedCookieDialog = localStorage.getItem('cookieDialog')
        this.cookieDialog = savedCookieDialog ? false : true
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        firstSection() {
            return `#${this.content.details[0].id}`
        },
        options () {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing
            }
        },
    },
    destroyed() {
        window.removeEventListener('online', this.updateConnectionStatus);
        window.removeEventListener('offline', this.updateConnectionStatus);
    },
}
</script>